"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var isTouchDevice = "ontouchstart" in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.maxTouchPoints > 0;
var TimelineTitle = function () {
    var t = (0, react_i18next_1.useTranslation)("en").t;
    return react_1["default"].createElement("p", { className: "TimelineTitle", style: { clear: "both" } },
        react_1["default"].createElement("u", null, t('timeline-title')),
        isTouchDevice ?
            react_1["default"].createElement("span", { style: { float: "right", padding: "0px 2px 0px 2px" } }, t('mobile-instructions'))
            :
                react_1["default"].createElement("span", { style: { float: "right", padding: "0px 2px 0px 2px" } }, t('desktop-instructions')));
};
exports["default"] = TimelineTitle;
